import { LinearProgress } from "@mui/material";
import { useNavigation } from "react-router";

/**
 * Indeterminate top bar while a lazy route chunk is loading.
 * @returns {import("react").JSX.Element | null}
 */
export default function RouteNavigationProgress() {
  const navigation = useNavigation();
  if (navigation.state !== "loading") {
    return null;
  }
  return (
    <LinearProgress
      aria-label="Loading page"
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        height: 3,
        zIndex: (theme) => theme.zIndex.drawer + 3,
      }}
    />
  );
}
